<mat-dialog-content>
  <form [formGroup]="providerForm">
    <h3>
      <strong>{{ 'Modify Provider' | translate }}</strong>
    </h3>
    <div class="row">
      <div class="col-md-4">
        <span>{{ 'Person Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="personType"
          [compareWith]="comparePersonType"
        >
          <option selected value="">{{ 'Select Type' | translate }}</option>
          @for (types of personTypes; track types) {
            <option [ngValue]="types">
              {{ types.type }}
            </option>
          }
        </select>
        @if (textValid('personType')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span>{{ 'Document Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="types_docs"
          [compareWith]="compareDocType"
        >
          @for (types of documenTypeList; track types) {
            <option [ngValue]="types">
              {{ types.description }}
            </option>
          }
        </select>
        @if (textValid('types_docs')) {
          <span class="form-text text-danger">{{
            'You must select a type' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Document Or Nit' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Document/Nit' | translate }}"
          formControlName="doc_nit"
        />
        @if (textValid('doc_nit')) {
          <span class="form-text text-danger">{{
            'The document must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-1">
        <span> {{ 'DV' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'DV' | translate }}"
          formControlName="verification_digit"
        />
        @if (textValid('verification_digit')) {
          <span class="form-text text-danger">{{
            'The verification digit must be only 1 numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Provider Name' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Name' | translate }}"
          formControlName="name"
        />
        @if (textValid('name')) {
          <span class="form-text text-danger">{{
            'The name must be wrote' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Provider Phone' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Phone' | translate }}"
          formControlName="phone"
        />
        @if (textValid('phone')) {
          <span class="form-text text-danger">{{
            'The phone must be only numbers' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Provider Email' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Email' | translate }}"
          formControlName="email"
        />
        @if (textValid('email')) {
          <span class="form-text text-danger">{{
            'The email is not a valid' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Provider Country' | translate }}:</span>
        <select
          class="form-control"
          formControlName="country"
          [compareWith]="compareCountry"
        >
          @for (country of countryList; track country) {
            <option [ngValue]="country">{{ country.name }}</option>
          }
        </select>
        @if (textValid('country')) {
          <span class="form-text text-danger">{{
            'The country is not valid' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'City' | translate }}:</span>
        <input
          class="form-control"
          [matAutocomplete]="autocompleteCity"
          placeholder="{{ 'Select city' | translate }}"
          formControlName="citySelect"
        />
        <mat-autocomplete
          (optionSelected)="setCitySelected()"
          #autocompleteCity="matAutocomplete"
          [displayWith]="displayFnCity"
        >
          @if (!providerCountryIsColombia) {
            @for (city of filterCities$ | async; track city) {
              <mat-option [value]="city">
                {{ city }}
              </mat-option>
            }
          }
          @if (providerCountryIsColombia) {
            @for (city of filterCitiesForColombia$ | async; track city) {
              <mat-option [value]="city">
                {{ city.name }}
              </mat-option>
            }
          }
        </mat-autocomplete>
        @if (textValid('city')) {
          <span class="form-text text-danger">{{
            'The city is not valid' | translate
          }}</span>
        }
      </div>
      <div class="col-md-4">
        <span> {{ 'Provider Address' | translate }}:</span>
        <input
          class="form-control"
          placeholder="{{ 'Address' | translate }}"
          formControlName="address"
        />
        @if (textValid('address')) {
          <span class="form-text text-danger">{{
            'The address must be wrote' | translate
          }}</span>
        }
      </div>
      @if (countryIsColombia) {
        <div class="col-md-4">
          <span> {{ 'Company Type' | translate }}:</span>
          <select
            class="form-control"
            formControlName="type"
            [compareWith]="compareType"
          >
            <option selected value="">{{ 'Select type' | translate }}</option>
            @for (type of companyTypeList; track type) {
              <option [ngValue]="type">{{ type.name | translate }}</option>
            }
          </select>
          @if (textValid('type')) {
            <span class="form-text text-danger">{{
              'The type is not valid' | translate
            }}</span>
          }
        </div>
        <div class="col-md-4">
          <span>{{ 'Activity Code' | translate }}:</span>
          <input
            class="form-control"
            [matAutocomplete]="autocompleteActivity"
            placeholder="{{ 'Select a option' | translate }}"
            formControlName="activity_ciiu"
          />
          <mat-autocomplete
            #autocompleteActivity="matAutocomplete"
            [displayWith]="displayFnActivity"
          >
            @for (activity of activitiesList; track activity) {
              <mat-option [value]="activity">
                {{ activity.activity_description }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (textValid('activity_ciiu')) {
            <span class="form-text text-danger">{{
              'You must select a activity' | translate
            }}</span>
          }
        </div>
      }
      <div class="col-md-4">
        <span>{{ 'Contributor Type' | translate }}:</span>
        <select
          class="form-control"
          formControlName="contributorType"
          [compareWith]="compareContributor"
        >
          @for (contributor of contributorTypeList; track contributor) {
            <option [ngValue]="contributor">
              {{ contributor.description }}
            </option>
          }
        </select>
        @if (textValid('contributorType')) {
          <span class="form-text text-danger">{{
            'You must select a contributor type' | translate
          }}</span>
        }
      </div>
      @if (countryIsColombia) {
        <div class="col-md-4">
          <span> {{ 'Regime' | translate }}:</span>
          <select
            (change)="filterDeclarantList()"
            class="form-control"
            formControlName="regime"
            [compareWith]="compareRegime"
          >
            <option selected value="">{{ 'Select regime' | translate }}</option>
            @for (regime of regimeList; track regime) {
              <option [ngValue]="regime">{{ regime.name | translate }}</option>
            }
          </select>
          @if (textValid('regime')) {
            <span class="form-text text-danger">{{
              'The regime is not valid' | translate
            }}</span>
          }
        </div>
      }
      @if (declarantsList.length > 0) {
        <div class="col-md-4">
          <span> {{ 'Declarant Type' | translate }}:</span>
          <select
            class="form-control"
            formControlName="declarant"
            [compareWith]="compareDeclarant"
          >
            <option selected value="">
              {{ 'Select declarant' | translate }}
            </option>
            @for (declarant of declarantsList; track declarant) {
              <option [ngValue]="declarant">
                {{ declarant.name | translate }} -
                {{ declarant.type | translate }}
              </option>
            }
          </select>
          @if (textValid('declarant')) {
            <span class="form-text text-danger">{{
              'The regime is not valid' | translate
            }}</span>
          }
        </div>
      }
    </div>
    <div class="row">
      <div
        class="row"
        style="padding-left: 20px; margin-top: 10px; margin-bottom: 10px"
        id="buttons-div"
      >
        <div class="col" id="buttons">
          <button (click)="update()" mat-raised-button>
            {{ 'Modify' | translate }}
          </button>
        </div>
        <div class="col" id="buttons">
          <button mat-raised-button [mat-dialog-close]>
            {{ 'Cancel' | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</mat-dialog-content>

<ngx-spinner
  type="ball-scale-multiple"
  template="<img src='../../../../../../assets/gif/V1-Insight-Icon-for-gif-2.gif' />"
  bdColor="rgba(51,51,51,0.8)"
>
  <p style="font-size: 20px; color: #ffffff">{{ 'Loading...' | translate }}</p>
</ngx-spinner>
